import React, { useEffect, useRef } from 'react';
import { NavLink, Outlet, useLocation } from 'react-router-dom';
import { useT } from '../lang.js';
import Icon from '../Icon.jsx';

// Ayar niteliğindeki ekranlar ana gezinmeyi şişiriyordu (on bir bağlantı).
// Günlük işte kullanılanlar solda kalır (Genel, Salon, Menü, Mutfak,
// Tahsilat); kurulumda bir kez dokunulanlar burada sekmeye iner.
// Etiketler yine `nav.*` anahtarlarından — iki yerde iki ad olmasın.
const TABS = [
  ['/settings', 'set.tabGeneral', true, 'sliders'],
  ['/settings/overview', 'set.tabOverview', false, 'gauge'],
  ['/settings/staff', 'nav.staff', false, 'users'],
  ['/settings/accounts', 'set.tabAccounts', false, 'cash'],
  ['/settings/printers', 'nav.printers', false, 'printer'],
  ['/settings/loyalty', 'nav.loyalty', false, 'gift'],
  ['/settings/devices', 'nav.devices', false, 'phone'],
  ['/settings/billing', 'nav.plan', false, 'tag'],
];

export default function SettingsShell() {
  const t = useT();
  const loc = useLocation();
  const bar = useRef(null);

  // Telefonda şerit yatay kayıyor: açılan sekme ekranın dışında kalmasın.
  useEffect(() => {
    const on = bar.current?.querySelector('a.on');
    on?.scrollIntoView({ block: 'nearest', inline: 'center' });
  }, [loc.pathname]);

  return (
    <>
      <nav className="tabs" aria-label={t('nav.settings')} ref={bar}>
        {TABS.map(([to, key, end, icon]) => (
          <NavLink key={to} to={to} end={!!end} className={({ isActive }) => (isActive ? 'on' : '')}>
            <Icon n={icon} />{t(key)}
          </NavLink>
        ))}
      </nav>
      <Outlet />
    </>
  );
}
